module.exports = __webpack_public_path__ + "static/media/cartasDisabled.95fdca7d.svg";